import Box from '@mui/material/Box';
import Dashboard from './Dashboard';

export default function AdminHome() {
    return (
        <>
            <Box display="flex">
                <Dashboard />
            </Box>
        </>
    )
}
